import React, { useEffect, useState } from "react";
import "./manageCouponDetails.scss";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import snackbarStore from "../../../stores/snackbarStore";
import sidebarActivePage from "../../../stores/sidebarActivePage";
import SnackbarAlert from "../../../components/snackbarAlert/snackbarAlert";
import TwoBreadcrumb from "../../../components/breadcrumbs/TwoBreadcrumb";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker
import couponStore from "../../../stores/couponStore";
import IOSSwitch from "../../../components/iosSwitch/IOSSwitch";

const ManageCoupon = () => {
  const SnackbarStore = snackbarStore();
  const CouponStore = couponStore();
  const SidebarActivePage = sidebarActivePage();
  const params = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const todayDate = new Date();

  useEffect(() => {
    window.scrollTo({ top: "0px" });
    if (params.couponID) {
      if (CouponStore.couponForm.couponName === "") {
        navigate("/coupon");
      }
    }
    SidebarActivePage.setIsActive({ setPage: "Coupon" });
    setIsLoading(false);
  }, []);

  const handleClick = async () => {
    const isValid = await CouponStore.checkValidation();
    if (isValid) {
      // Call API
      let res = false;
      setIsLoading(true);
      if (params.couponID) {
        res = await CouponStore.updateCoupon({ couponID: params.couponID });
        if (res) SnackbarStore.setMassage({ value: "Update Successfully" });
      } else {
        res = await CouponStore.createCoupon();
        if (res) SnackbarStore.setMassage({ value: "Create Successfully" });
      }
      setIsLoading(false);

      if (res) return navigate("/coupon");
    }
  };

  return (
    <div className="manage-coupon w-100">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container>
        <Grid item xs={12}>
          <div className="heading">
            {params.couponID !== undefined ? "Edit" : "Create a new coupon"}
          </div>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <TwoBreadcrumb
            mainName="Coupon"
            mainLink="coupon"
            activeName={
              params.couponID !== undefined ? "Edit Coupon" : "New Coupon"
            }
          />
        </Grid>
      </Grid>
      <Grid container className="gridContainer">
        <Grid
          container
          item
          xs={1}
          md={5}
          lg={5}
          display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          className="gridTitles"
        >
          <Grid item xs={12}>
            <h2>Details</h2>
            <p>
              Title, short description,
              <br /> discount percentage...
            </p>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={7}
          sm={12}
          lg={7}
          spacing={3}
          className="gridContent"
          component="form"
        >
          <Grid item xs={12} className="gridContentTitle">
            <h2>Details</h2>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Coupon Name"
              variant="outlined"
              fullWidth
              className="couponName"
              name="couponName"
              value={CouponStore.couponForm.couponName}
              onChange={(e) => {
                const { name, value } = e.target;
                CouponStore.setCouponForm({ name, value });
              }}
              error={CouponStore.validationCouponForm.couponName}
              helperText={
                CouponStore.validationCouponForm.couponName &&
                "Coupon Name is require"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Short Description Name"
              variant="outlined"
              fullWidth
              className="shortDescription"
              name="shortDescription"
              value={CouponStore.couponForm.shortDescription}
              onChange={(e) => {
                const { name, value } = e.target;
                CouponStore.setCouponForm({ name, value });
              }}
              error={CouponStore.validationCouponForm.shortDescription}
              helperText={
                CouponStore.validationCouponForm.shortDescription &&
                "Coupon Name is require"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Discount (in percentage)"
              variant="outlined"
              inputProps={{ inputMode: "numeric" }}
              fullWidth
              className="discount"
              name="discount"
              value={CouponStore.couponForm.discount}
              onChange={(e) => {
                const { name, value } = e.target;
                if (!isNaN(value)) {
                  CouponStore.setCouponForm({ name, value });
                }
              }}
              error={CouponStore.validationCouponForm.discount}
              helperText={
                CouponStore.validationCouponForm.discount &&
                "Coupon Name is require"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Minimum Order Value"
              variant="outlined"
              inputProps={{ inputMode: "numeric" }}
              fullWidth
              className="min-order-value"
              name="minOrderValue"
              value={CouponStore.couponForm.minOrderValue}
              onChange={(e) => {
                const { name, value } = e.target;
                if (!isNaN(value)) {
                  CouponStore.setCouponForm({ name, value });
                }
              }}
              error={CouponStore.validationCouponForm.minOrderValue}
              helperText={
                CouponStore.validationCouponForm.minOrderValue &&
                "Coupon Name is require"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              label="Total No. Of Voucher"
              variant="outlined"
              inputProps={{ inputMode: "numeric" }}
              fullWidth
              className="total-voucher"
              name="totalNoOfVoucher"
              value={CouponStore.couponForm.totalNoOfVoucher}
              onChange={(e) => {
                const { name, value } = e.target;
                if (!isNaN(value)) {
                  CouponStore.setCouponForm({ name, value });
                }
              }}
              error={CouponStore.validationCouponForm.totalNoOfVoucher}
              helperText={
                CouponStore.validationCouponForm.totalNoOfVoucher &&
                "Coupon Name is require"
              }
            />
          </Grid>
          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={[
                  "DatePicker",
                  "DesktopDatePicker",
                  "MobileDatePicker",
                ]}
              >
                <DatePicker
                  label="Validity Date"
                  minDate={dayjs(todayDate)}
                  format="DD/MM/YYYY"
                  name="validityDate"
                  value={CouponStore.couponForm.validityDate}
                  onChange={(value) => {
                    CouponStore.setCouponForm({ name: "validityDate", value });
                  }}
                />
              </DemoContainer>
              {CouponStore.validationCouponForm.validityDate && (
                <FormHelperText sx={{ color: "#cc0000", ml: "15px" }}>
                  Select Data
                </FormHelperText>
              )}
            </LocalizationProvider>
          </Grid>
        </Grid>
        <Grid container item xs={12} mt="20px">
          <Grid
            container
            item
            xs={0}
            md={5}
            lg={5}
            display={{ xs: "none", lg: "block", sm: "none", md: "block" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                fontWeight: "700",
              }}
            >
              <FormControlLabel
                name="publish"
                checked={CouponStore.couponForm.publish}
                control={<IOSSwitch sx={{ m: 1 }} />}
                onChange={() => {
                  CouponStore.setCouponForm({
                    name: "publish",
                    value: !CouponStore.couponForm.publish,
                  });
                }}
              />
              Publish
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={7}
            sm={12}
            lg={7}
            sx={{ justifyContent: "flex-end" }}
            className="btnContainer"
          >
            <Button variant="contained" className="btn" onClick={handleClick}>
              <p>
                {params.couponID !== undefined
                  ? "Save Changes"
                  : "Create Coupon"}
              </p>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ManageCoupon;
